import React from 'react'

import { getValueFormat } from '@baurine/grafana-value-formats'

import { unitMap } from '~/pages/reports/shared/utils/unit'

import { ComponentData } from '../table_component'
import { getUnit } from './util'

export const TopNComp: React.FC<
  ComponentData & { topN: number; metricKey: string; subKeys?: string[] }
> = ({ metricStats, column, topN, metricKey, subKeys = [] }) => {
  const metric = metricStats[metricKey]
  if (!metric) {
    return <span>{metricKey}</span>
  }

  const value = metric.values[column.id]
  const d = value?.value as {
    [k: string]: number
  }
  if (!d) {
    return <span>{metricKey}</span>
  }

  const subKeyValues = subKeys.map((k) => metric.values[k]).filter((v) => !!v)

  const dArr = Object.entries(d)
  if (!dArr.length) {
    return <span>{metricKey}</span>
  }

  const sorted = dArr.sort((a, b) => {
    const aValNum = a[1]
    const bValNum = b[1]
    if (aValNum > bValNum) {
      return -1
    }
    if (aValNum < bValNum) {
      return 1
    }
    return 0
  })
  const Info: React.FC<{ unit: string; data: [string, number] }> = ({
    unit,
    data
  }) => (
    <>
      <span>
        {data[0]}: {getValueFormat(unit)(data[1], 2)}
        {!!subKeyValues.length && (
          <>
            (
            {subKeyValues
              .map((v) =>
                getValueFormat(unitMap[v.unit!] || unit)(v.value?.[data[0]], 2)
              )
              .join(', ')}
            )
          </>
        )}
      </span>
      <br />
    </>
  )
  const unit = getUnit(metric, value)

  return (
    <>
      {sorted.slice(0, topN).map((d, index) => (
        <Info key={index} unit={unit} data={d} />
      ))}
    </>
  )
}

export const TopN =
  (n: number, metricKey: string, subKeys?: string[]): React.FC<ComponentData> =>
  (props) => {
    return (
      <TopNComp topN={n} metricKey={metricKey} subKeys={subKeys} {...props} />
    )
  }
